var _react_refresh_temp_1;
_react_refresh_temp_1 = $RefreshSig$();
import { useMutation } from '@tanstack/react-query';
import { createFetcher, defaultFetch } from '@lucidlink/sdk/fetcher';
import { NINETY_DAYS } from '@lucidlink/sdk/test/helpers/backdoor';
import { DEPENDENCY_KEYS, useDependency } from '#context';
export const useEnterpriseMonthlyConversion = (workspaceId, { onError, onSettled, onSuccess } = {}) => {
    _react_refresh_temp_1();
    const webServiceEndpoint = useDependency(DEPENDENCY_KEYS.WEB_SERVICE_ENDPOINT);
    const mutation = useMutation({
        mutationFn: async () => {
            const now = new Date();
            const fetcher = createFetcher({
                baseUrl: webServiceEndpoint,
                baseUrlHasVersion: true,
                fetch: defaultFetch,
            });
            const body = {
                subscription: {
                    type: 'monthly',
                    contractStartDate: now,
                    members: { prepaid: { price: 0 }, overage: { price: 0 } },
                    awsStorage: { overage: { price: 0 } },
                },
                invoice: {
                    daysUntilDue: NINETY_DAYS,
                },
            };
            await fetcher.put(['testing', 'workspaces', workspaceId, 'enterprise'], { body });
        },
        onSuccess: () => {
            if (typeof onSuccess === 'function') {
                onSuccess();
            }
        },
        onError: (error) => {
            if (typeof onError === 'function') {
                onError(error);
            }
        },
        onSettled: () => {
            if (typeof onSettled === 'function') {
                onSettled();
            }
        },
    });
    return {
        mutation,
    };
};
_react_refresh_temp_1(useEnterpriseMonthlyConversion, "68blas1aZXyiiV4KHjO0G2Dn8BY=", false, () => [useDependency, useMutation]);
